import type { FC } from 'react';
import { Box, Button } from '@mui/material';
import { CopyAll } from '@mui/icons-material';

interface AdSetApplyToAllButtonProps {
  onClick: () => void;
  testId: string;
  ariaLabel: string;
  disabled?: boolean;
}

export const AdSetApplyToAllButton: FC<AdSetApplyToAllButtonProps> = ({
  onClick,
  testId,
  ariaLabel,
  disabled,
}) => (
  <Box className="MuiInputAdornment-positionEnd">
    <Button
      data-testid={testId}
      onClick={onClick}
      size="small"
      disabled={disabled}
      sx={{ textTransform: 'initial', px: 1 }}
      startIcon={<CopyAll />}
      aria-label={ariaLabel}
    >
      Apply to all
    </Button>
  </Box>
);
